import {h, Component, Fragment} from 'preact';
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

import * as P from "../desktop-templates/prematch-tournament.jsx";
import AwrabetPrematchTournamentSelector from '../../awrabet/desktop-components/prematch-tournament-selector.jsx';

export default class PrematchTournamentSelector extends AwrabetPrematchTournamentSelector {
	render() {
		return <div>
		  <P.TournamentSelectorHead>
			<P.TournamentHeadCell>
			  <P.OneDotAlt />
			  <P.CardHeaderTitle><Trans>Football</Trans></P.CardHeaderTitle>
			</P.TournamentHeadCell>
			<P.TournamentHeadButtonCell />
			<P.TournamentHeadButtonCell />
			<P.TournamentHeadButtonCell />
		  </P.TournamentSelectorHead>
		  <div>
			<P.CategoryNameRow>
			  <P.TournamentHeadCell>
				<P.ThreeDots />
				<P.CardHeaderTitle><Trans>Italy</Trans></P.CardHeaderTitle>
			  </P.TournamentHeadCell>
			  <P.TournamentHeadButtonCell />
			</P.CategoryNameRow>
			<P.CategoryContentsRow>
			  <P.TournamentCell>
				<P.TournamentCheckbox />
				<P.TournamentNameLabel>Hello</P.TournamentNameLabel>
			  </P.TournamentCell>
			  <P.TournamentCell>
				<P.TournamentCheckbox />
				<P.TournamentNameLabel>Hello</P.TournamentNameLabel>
			  </P.TournamentCell>
			  <P.TournamentCell>
				<P.TournamentCheckbox />
				<P.TournamentNameLabel>Hello</P.TournamentNameLabel>
			  </P.TournamentCell>
			  <P.TournamentCell>
				<P.TournamentCheckbox />
				<P.TournamentNameLabel>Hello</P.TournamentNameLabel>
			  </P.TournamentCell>
			  <P.TournamentCell>
				<P.TournamentCheckbox />
				<P.TournamentNameLabel>Hello</P.TournamentNameLabel>
			  </P.TournamentCell>
			</P.CategoryContentsRow>
		  </div>
		</div>
	}
}
